// store/index.js
import { createStore } from 'vuex';
import userModule from './modules/user';
import themeModule from './modules/theme';
import licensesModule from './modules/licenses';
import usersModule from './modules/users';
import applicationWebViewModule from './modules/applicationWebView'

export default createStore({
  modules: {
    user: userModule,
    theme: themeModule,
    licenses: licensesModule,
    users: usersModule,
    applicationWebView: applicationWebViewModule
  }
});